import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {IonicModule} from "@ionic/angular";
import {
  ConfigureVisitCategoriesForVetcodeModalComponent
} from "./configure-visit-categories-for-vetcode-modal.component";


@NgModule({
  declarations: [ConfigureVisitCategoriesForVetcodeModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    DragDropModule
  ],
  exports: [ConfigureVisitCategoriesForVetcodeModalComponent],
})
export class ConfigureVisitCategoriesForVetcodeModule {}
